import React from "react";

const ClinicManagementHeader = () => {
  return (
    <div className="mb-6">
      <h3 className="text-2xl font-bold text-navy-700 dark:text-white">
        Clinic Management
      </h3>
      <p className="text-gray-600 dark:text-gray-300">
        Manage clinic settings, staff, services, and performance
      </p>
    </div>
  );
};

export default ClinicManagementHeader;
